import { get } from "svelte/store"

import { getLinkByHash } from "./get_link_by_hash";
import { request } from "./request";
import { getHashByType } from "./change_hash";

import { menuData, contentShellData, entityData } from "../stores/data";
import { menuEntity, currentHash, noNeedSendButton, currentEntityID, isDataLoaded } from "../stores/variables";
import { debug } from "svelte/internal";

export function getData(options = {}) {
	let menu = get(menuData);
	let list = menu.list;
	let hash = get(currentHash);
	let mEntity = get(menuEntity);
	let menuHash = getHashByType(hash, menu.type);
	let addHash = getHashByType(hash, mEntity);

	let link = getLinkByHash(list, menuHash);

	let opts = [];
	if (link && link.options) {
		opts = link.options;
	}

	noNeedSendButton.set(!opts.sendButton);

	let fields = [];

	let buildData = get(contentShellData);
	if (buildData) {
		buildData.blocks.forEach((block) => {
			if (block.field_names) fields.push(...block.field_names);
		});
	}

	if (mEntity != "doctor") {
		currentEntityID.set(+addHash);
	}
	let sendData = {
		id: +addHash,
		fields: fields,
	};

	let requestName = "";
	let ignoreEntityID = false;
	let requestNeed = false;

	if (mEntity == "clinic") {
		requestName = "clinicdata";
	}
	if (mEntity == "doctor") {
		requestName = "doctordata";
		sendData.id = +get(currentEntityID);
	}

	if (opts.requestUrl) {
		requestNeed = true;
		requestName = opts.requestUrl;
	}
	if (opts.ignoreEntityID) {
		ignoreEntityID = true;
		delete sendData.id;
	}
	if (opts.ignoreFields) {
		delete sendData.fields;
	}

	opts.ignoreRequest ? requestNeed = false : requestNeed = true

	if (requestNeed) {
		request.fetchData(requestName, "navigation", sendData).then((result) => {
			buildData.blocks.forEach((block) => {
				if (!block.field_names) block.field_names = [];
				if (!block.newData) block.newData = [];
				block.field_names.forEach(raw => {
					block.newData[raw] = result.data[raw];
				})
			});
			entityData.set(result.data);
			contentShellData.set(buildData);
		})
	}

}